"use strict";

(function () {
  document.querySelectorAll('.faq').forEach(function (faq) {
    var collapse = faq.querySelector('[data-expand-all]');
    collapse === null || collapse === void 0 || collapse.addEventListener('click', function () {
      var items = faq.querySelectorAll('.faq_block__input');
      var isCollapsed = faq.querySelectorAll('.faq_block__input.checked').length;
      var btnText = collapse.querySelector(".btn--text");
      btnText.innerHTML = isCollapsed ? collapse.dataset.textExpand : collapse.dataset.textCollapse;
      collapse.setAttribute("aria-expanded", isCollapsed ? "false" : "true");
      items.forEach(function (item) {
        return isCollapsed ? item.classList.remove('checked') : item.classList.add('checked');
      });
    });
  });
})();